import Detail from '../../../../components/Detail';
import { formatUSD } from '../../../../helpers/formats';
import useRealizedPerformanceFeesToDate from '../../../../hooks/web3/vault/useRealizedPerformanceFeesToDate';

const CommunityRealizedPerformanceFeesToDate = () => {
    const { realizedPerformanceFeesToDate } = useRealizedPerformanceFeesToDate();

    return (
        <Detail
            title={
                <>
                    <span>Realized Performance Fees to date</span>
                </>
            }
            value={<>~${formatUSD(realizedPerformanceFeesToDate || '0')}</>}
        />
    );
};

export default CommunityRealizedPerformanceFeesToDate;
